import { render, staticRenderFns } from "./QMLayout.vue?vue&type=template&id=499d9aba&scoped=true"
import script from "./QMLayout.vue?vue&type=script&lang=js"
export * from "./QMLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d9aba",
  null
  
)

export default component.exports